// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyCtaFooter-cls1_Pby","cls2":"StickyCtaFooter-cls2_Rn5 StickyCtaFooter-cls1_Pby","hidden":"StickyCtaFooter-hidden_aTe"};